module.exports = __webpack_public_path__ + "static/user-segmentation-hero-2508f8b66dac67c584de37ca9b87a76f.png";